module.exports = __webpack_public_path__ + "img/34_17.b2f9ebd5.png";